// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__3Im3F","imageUploader":"EGiftCard_imageUploader__3Pu0h"};